module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/todo_lv-ee902a1ce845051699b75691320002b3.webp";